export default __webpack_public_path__ + "static/media/grid2_transparent.3918fa64.png";